import { useAuth } from 'app/provider/auth'
import { ChatsScreen } from './chats-screen'
import { useUserChatsQuery, userChatsQuery } from '../../queries'
import { useState } from 'react'

export interface ChatsScreenContainerProps {
  HeaderComponent?: React.ReactNode
}

export const ChatsScreenContainer = (props: ChatsScreenContainerProps) => {
  const { user } = useAuth()

  const [searchTerm, setSearchTerm] = useState('')
  const [refreshing, setRefreshing] = useState(false)

  const {
    data: userChatData,
    loading: userChatsLoading,
    refetch: refetchUserChats,
    fetchMore,
    networkStatus,
  } = useUserChatsQuery({
    variables: {
      ...userChatsQuery.defaultVariables,
      searchTerm,
    },
    fetchPolicy: 'cache-and-network',
    pollInterval: 10000, // 10 seconds
    skip: !user,
  })

  const userChats = userChatData?.searchChats
  const formattedUserChats = userChatsQuery.mapFn(userChats, user?.id || '')

  const totalDocs = userChats?.totalDocs || 0
  const hasMore = totalDocs > formattedUserChats.length

  const handleFetchMore = async () => {
    if (!hasMore || !userChats) return
    await fetchMore({
      variables: {
        page: userChats.page + 1,
      },
    })
  }

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetchUserChats()])
    setRefreshing(false)
  }

  return (
    <ChatsScreen
      HeaderComponent={props.HeaderComponent}
      user={user}
      searchTerm={searchTerm}
      onSearchTermChange={setSearchTerm}
      userChats={formattedUserChats}
      userChatsLoading={userChatsLoading}
      userChatsFetchingMore={networkStatus === 3}
      hasMore={hasMore}
      fetchMore={handleFetchMore}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
